import AppSkeletonBuyCardList from "@core-components/product/component/AppSkeletonBuyCardList";
import { useLoaderStore } from "@modules/loader/useLoader.hook";
import type { FC } from "react";
import AccountCarousel, {
  type ICarouselProps,
} from "./components/AccountCarousel";
import AccountList, { type IListAccountProps } from "./components/AccountList";

const List: FC<IListAccountProps> = (props) => {
  const useLoader = useLoaderStore();

  if (useLoader.isLoadingBySkeleton()) {
    return <AppSkeletonBuyCardList />;
  }

  return <AccountList {...props} />;
};

const Carousel: FC<ICarouselProps> = (props) => {
  const useLoader = useLoaderStore();

  if (useLoader.isLoadingBySkeleton()) {
    return <AppSkeletonBuyCardList />;
  }

  return <AccountCarousel {...props} />;
};

const AccountDisplay = {
  List,
  Carousel,
};

export default AccountDisplay;
